import * as React from 'react';
import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

import withIconWrapper from 'app/hocs/withIconWrapper';

export default withIconWrapper(function PurchaseTickets({ color, size, ...props }) {
  return (
    <Svg fill="none" height={size} viewBox="0 0 24 24" width={size} {...props}>
      <G clipPath="url(#purchase-tickets-clip)">
        <Path
          d="M11.6922 19.599L18.4955 20.7986C18.6127 20.8223 18.7335 20.8219 18.8505 20.7974C18.9676 20.7729 19.0784 20.725 19.1764 20.6564C19.2743 20.5878 19.3573 20.5 19.4203 20.3984C19.4834 20.2968 19.5251 20.1834 19.5429 20.0652L19.8787 18.1608C19.8949 18.0628 19.8807 17.9622 19.8379 17.8725C19.7951 17.7829 19.7258 17.7086 19.6394 17.6595C19.3515 17.5389 19.1153 17.3205 18.9724 17.043C18.8295 16.7654 18.7891 16.4463 18.8582 16.1418C18.9188 15.8419 19.0724 15.5687 19.2974 15.3612C19.5223 15.1537 19.8069 15.0224 20.1108 14.9862C20.2087 14.9696 20.2993 14.9234 20.3701 14.8539C20.441 14.7843 20.4888 14.6946 20.5071 14.597L20.8429 12.6926C20.8666 12.5754 20.8661 12.4546 20.8417 12.3375C20.8172 12.2205 20.7693 12.1096 20.7007 12.0117C20.6321 11.9137 20.5443 11.8307 20.4427 11.7677C20.3411 11.7047 20.2277 11.663 20.1095 11.6451L17.2483 11.1406"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={23.333}
          strokeWidth={1.5}
        />
        <Path
          d="M18.0942 11.2864L7.32922 9.38822C7.21201 9.36458 7.09121 9.365 6.97416 9.38945C6.85711 9.4139 6.74625 9.46188 6.6483 9.53046C6.55035 9.59905 6.46735 9.68682 6.40434 9.78844C6.34133 9.89007 6.29962 10.0034 6.28174 10.1217L5.94595 12.0261C5.92014 12.1244 5.93002 12.2287 5.97384 12.3205C6.01765 12.4123 6.09257 12.4856 6.18528 12.5273C6.35423 12.5993 6.50722 12.704 6.63537 12.8355C6.76352 12.9671 6.86428 13.1227 6.9318 13.2935C6.99932 13.4642 7.03226 13.6467 7.02871 13.8303C7.02516 14.0139 6.98519 14.1949 6.91111 14.363C6.80802 14.5993 6.64168 14.8026 6.43044 14.9504C6.21919 15.0982 5.97123 15.1848 5.71389 15.2007C5.61595 15.2172 5.52543 15.2634 5.45455 15.333C5.38368 15.4026 5.33586 15.4923 5.31755 15.5899L4.98176 17.4943C4.95812 17.6115 4.95854 17.7323 4.98299 17.8493C5.00744 17.9664 5.05541 18.0772 5.124 18.1752C5.19258 18.2731 5.28035 18.3561 5.38198 18.4191C5.48361 18.4822 5.59698 18.5239 5.71521 18.5417L12.0745 19.6631"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={23.333}
          strokeWidth={1.5}
        />
        <Path
          d="M9.58165 16.9511L9.75256 15.9818"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
        />
        <Path
          d="M10.2464 13.1812L10.4174 12.2118"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
        />
        <Path
          d="M16.7015 8.56096C16.5125 8.3124 16.4173 8.00519 16.4325 7.69336C16.4401 7.38743 16.544 7.0917 16.7295 6.84829C16.9149 6.60488 17.1725 6.4262 17.4654 6.33772C17.559 6.30444 17.6401 6.24324 17.6978 6.16239C17.7555 6.08155 17.7871 5.98495 17.7882 5.88562V3.95186C17.7911 3.83232 17.7697 3.71343 17.7253 3.60241C17.6809 3.49138 17.6144 3.39053 17.5298 3.30598C17.4453 3.22143 17.3444 3.15493 17.2334 3.11053C17.1224 3.06612 17.0035 3.04473 16.884 3.04766H13.9786"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={23.333}
          strokeWidth={1.5}
        />
        <Path
          d="M14.837 3.04433L3.90589 3.04433C3.78635 3.04141 3.66746 3.06279 3.55644 3.1072C3.44541 3.1516 3.34456 3.2181 3.26001 3.30265C3.17546 3.3872 3.10896 3.48805 3.06456 3.59908C3.02015 3.7101 2.99877 3.82899 3.00169 3.94853L3.00169 5.8823C2.99336 5.98364 3.0212 6.08467 3.08029 6.16743C3.13937 6.2502 3.22587 6.30935 3.32443 6.33439C3.50331 6.37589 3.67216 6.45249 3.8212 6.55976C3.97024 6.66703 4.0965 6.80282 4.19264 6.95926C4.28879 7.1157 4.35292 7.28968 4.3813 7.4711C4.40969 7.65252 4.40176 7.83777 4.35799 8.0161C4.2975 8.26673 4.16899 8.4958 3.98662 8.67805C3.80425 8.8603 3.5751 8.98867 3.32443 9.049C3.23084 9.08229 3.14972 9.14348 3.09201 9.22433C3.03429 9.30517 3.00277 9.40177 3.00169 9.5011V11.4349C2.99877 11.5544 3.02015 11.6733 3.06456 11.7843C3.10896 11.8953 3.17546 11.9962 3.26001 12.0807C3.34456 12.1653 3.44541 12.2318 3.55644 12.2762"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={23.333}
          strokeWidth={1.5}
        />
        <Path
          d="M7.43738 6.27303L7.43738 5.28876"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
        />
      </G>
      <Defs>
        <ClipPath id="purchase-tickets-clip">
          <Rect fill="white" height="20" transform="translate(2 2)" width="20" />
        </ClipPath>
      </Defs>
    </Svg>
  );
});
